import React from "react"

const path = _ => (
  <>
    <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0zM23.080 17.601l-7.898 7.898c-0.409 0.411-0.975 0.665-1.6 0.665s-1.191-0.254-1.6-0.665l-0-0c-0.409-0.41-0.663-0.976-0.663-1.601s0.253-1.191 0.663-1.601l4.7-4.7c0.411-0.409 0.666-0.975 0.666-1.601s-0.255-1.192-0.666-1.601l-0-0-4.704-4.697c-0.41-0.41-0.663-0.976-0.663-1.601 0-1.25 1.013-2.263 2.263-2.263 0.625 0 1.19 0.253 1.6 0.662l7.898 7.898c0.413 0.409 0.669 0.977 0.669 1.604 0 0.626-0.255 1.192-0.666 1.601l-0 0z"></path>
  </>
)

export default path
